import { AttributeLabelDetailsState } from "@idw-types/state/attribute-label-details-state";
import { getAttributeLabelDetailsState } from "@redux/selectors/root-selectors";
import { createSelector } from "reselect";

export const getAttributeLabelDetailsDataState = createSelector(getAttributeLabelDetailsState, (state: AttributeLabelDetailsState) => {
    return {
        isLoadingAxnAttributeLabel: state.attributeLabel.isLoading,
        axnAttributeLabel: state.attributeLabel.attributeLabel
    };
});